import { getLocalAuthStorage } from 'utils/localStorage';
import { refreshAuthLogic } from '../config'; // ajuste o path se necessário

const checkIfSessionExpired = async config => {
  const { token, expiresIn } = getLocalAuthStorage();
  if (config?.skipAuthRefresh) {
    return config;
  }
  if (!token || !expiresIn) return config;

  const now = Date.now();
  const expires = new Date(expiresIn).getTime();

  if (now >= expires) {
    await refreshAuthLogic({
      config,
      response: { status: 401 },
    });
  }

  return config;
};

export { checkIfSessionExpired };
